import { useEffect, useState } from "react";
import { api } from "../api";
import { money } from "../payrollPresentation";
import { payrollBatchWorkerTotals } from "../payrollBatchTotals";
import { Button } from "./ui/Button";
import { Feedback, TableFrame } from "./ui/Surface";
import "./PayrollBatchWorkerTotals.css";

export function PayrollBatchWorkerTotals({ batchId, revision }: { batchId: string; revision: string }) {
  const [attempt, setAttempt] = useState(0);
  const [state, setState] = useState<{ key: string; rows?: ReturnType<typeof payrollBatchWorkerTotals>; error?: string }>({ key: "" });
  const key = `${batchId}:${revision}:${attempt}`;
  useEffect(() => {
    let active = true;
    void api.getSettlementBatch(batchId).then(batch => { if (active) setState({ key, rows: payrollBatchWorkerTotals(batch) }); })
      .catch(cause => { if (active) setState({ key, error: cause instanceof Error ? cause.message : "작업자별 합계를 불러오지 못했습니다." }); });
    return () => { active = false; };
  }, [batchId, key]);
  const rows = state.key === key ? state.rows : undefined;
  const error = state.key === key ? state.error : undefined;
  const manual = rows?.some(row => row.manual !== 0);
  return <details open className="payroll-worker-totals" data-testid="settlement-worker-totals">
    <summary>작업자별 합산 금액</summary>
    {error ? <Feedback tone="error">{error} <Button size="compact" onClick={() => setAttempt(value => value + 1)}>합계 다시 확인</Button></Feedback>
      : !rows ? <p role="status">작업자별 합계를 불러오고 있습니다…</p>
      : <TableFrame label="작업자별 합산 금액">
        <thead><tr><th scope="col">작업자</th><th scope="col">정산액 (세전)</th>{manual && <th scope="col">수동 정산 (세후)</th>}<th scope="col">지급액 (세후)</th></tr></thead>
        <tbody>{rows.map(row => <tr key={row.workerId}><th scope="row">{row.name}</th><td>{money(row.taxableGross)}</td>{manual && <td>{money(row.manual)}</td>}<td>{money(row.payable)}</td></tr>)}</tbody>
        <tfoot><tr><th scope="row">합계 ({rows.length.toLocaleString()}명)</th><td>{money(rows.reduce((sum, row) => sum + row.taxableGross, 0))}</td>{manual && <td>{money(rows.reduce((sum, row) => sum + row.manual, 0))}</td>}<td>{money(rows.reduce((sum, row) => sum + row.payable, 0))}</td></tr></tfoot>
      </TableFrame>}
  </details>;
}
